module.exports = __webpack_public_path__ + "static/media/4532.565f1052.jpg";